/* Mom's Home PDP Option A: swipe gallery + Add to cart price/save sync */
(() => {
  if (window.mhPdpA) return;
  window.mhPdpA = true;
  const sub = (cb) => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      return subscribe(PUB_SUB_EVENTS.variantChange, (ev) => {
        const d = ev && ev.data;
        if (d && d.variant) cb(d.variant, d.sectionId);
      });
    }
    return null;
  };
  const fmt = (c) => (window.mhMoney ? window.mhMoney(c) : 'Rs.' + Math.round(c / 100).toLocaleString('en-US'));
  const pct = (v) => (v.compare_at_price > v.price ? Math.round(((v.compare_at_price - v.price) * 100) / v.compare_at_price) : 0);

  if (!customElements.get('mh-gallery')) {
    customElements.define(
      'mh-gallery',
      class extends HTMLElement {
        connectedCallback() {
          if (this.inited) return;
          this.inited = true;
          this.sid = this.dataset.section;
          this.track = this.querySelector('[data-mh-track]');
          this.slides = Array.from(this.track.children);
          this.thumbs = Array.from(this.querySelectorAll('.mh-gal__thumb'));
          this.dots = Array.from(this.querySelectorAll('.mh-gal__dots i'));
          this.cur = this.querySelector('[data-mh-cur]');
          this.badge = this.querySelector('[data-mh-badge]');
          this.idx = -1;
          const start = Number(this.dataset.start || 0);
          this.set(start);
          if (start) requestAnimationFrame(() => this.go(start, false));
          let raf = 0;
          this.track.addEventListener(
            'scroll',
            () => {
              if (raf) return;
              raf = requestAnimationFrame(() => {
                raf = 0;
                const w = this.track.clientWidth || 1;
                this.set(Math.round(this.track.scrollLeft / w));
              });
            },
            { passive: true }
          );
          this.thumbs.forEach((t) => t.addEventListener('click', () => this.go(Number(t.dataset.index))));
          this.querySelector('[data-mh-prev]')?.addEventListener('click', () => this.go(this.idx - 1));
          this.querySelector('[data-mh-next]')?.addEventListener('click', () => this.go(this.idx + 1));
          this.track.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.idx + 1); }
            if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.idx - 1); }
          });
          this.unsub = sub((v, sectionId) => {
            if (sectionId && sectionId !== this.sid) return;
            if (this.badge) {
              const p = pct(v);
              this.badge.hidden = p <= 0;
              this.badge.textContent = '-' + p + '%';
            }
            if (v.featured_media) {
              const s = this.track.querySelector(`[data-media-id="${this.sid}-${v.featured_media.id}"]`);
              if (s) this.go(Number(s.dataset.index));
            }
          });
        }
        disconnectedCallback() {
          this.unsub && this.unsub();
          this.inited = false;
        }
        go(i, smooth = true) {
          const n = this.slides.length;
          if (!n) return;
          i = (i + n) % n;
          const s = this.slides[i];
          this.track.scrollTo({ left: s.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
          this.set(i);
        }
        set(i) {
          if (i === this.idx || i < 0 || i >= this.slides.length) return;
          this.idx = i;
          this.slides.forEach((s, k) => s.classList.toggle('is-active', k === i));
          this.dots.forEach((d, k) => d.classList.toggle('on', k === Math.min(i, this.dots.length - 1)));
          if (this.cur) this.cur.textContent = i + 1;
          this.thumbs.forEach((t, k) => {
            if (k === i) {
              t.setAttribute('aria-current', 'true');
              const box = t.closest('[data-mh-thumbs]');
              if (box) {
                const li = t.parentElement;
                const vert = box.scrollHeight > box.clientHeight + 2 && box.scrollWidth <= box.clientWidth + 2;
                if (vert) box.scrollTo({ top: li.offsetTop - box.clientHeight / 2 + li.offsetHeight / 2, behavior: 'smooth' });
                else box.scrollTo({ left: li.offsetLeft - box.clientWidth / 2 + li.offsetWidth / 2, behavior: 'smooth' });
              }
            } else t.removeAttribute('aria-current');
          });
          // pause videos that are not active
          this.slides.forEach((s, k) => {
            if (k !== i) s.querySelectorAll('video').forEach((v) => v.pause && v.pause());
          });
        }
      }
    );
  }

  /* Add to cart: keep "· Rs X" + "SAVE X%" in sync with the selected variant */
  sub((v, sectionId) => {
    const btn = document.getElementById('ProductSubmitButton-' + sectionId);
    if (!btn || !btn.classList.contains('mh-atc')) return;
    const pr = btn.querySelector('[data-mh-atc-price]');
    const sv = btn.querySelector('[data-mh-atc-save]');
    if (pr) pr.textContent = fmt(v.price);
    if (sv) {
      const p = pct(v);
      sv.hidden = p <= 0;
      sv.textContent = 'SAVE ' + p + '%';
    }
  });
})();
